import axios from 'axios'

export default function() {
  console.log('setting up axios, csrf token', document.querySelector('meta[name=csrf-token]').content)
  axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name=csrf-token]').content
  axios.defaults.headers.common['Accept'] = 'application/json'
}
